// extracted by mini-css-extract-plugin
module.exports = {"container":"status_container__27Rjk","title":"status_title__oCth1"};